enum SubscriptionStatus {
  Active = 'Active',
  Expired = 'Closed',
  Pending = 'Pending',
  Terminated = 'Terminated',
  NonMember = 'None',
  Unknown = 'Unknown',
}
export default SubscriptionStatus;
